import { getFingerprintJSProPromise } from './fingerprintjs-pro'

export const FingerprintJSProHeadersNames = {
  REQUEST_ID: 'x-fp-request-id',
  VISITOR_ID: 'x-fp-visitor-id',
} as const

export type FingerprintJSProHeaders = {
  [FingerprintJSProHeadersNames.REQUEST_ID]?: string
  [FingerprintJSProHeadersNames.VISITOR_ID]?: string
}

export const getFingerprintJSProHeaders = async () => {
  const fingerprintJSProResponse = await getFingerprintJSProPromise()

  // send null if the visitor is not known instead of undefined
  return {
    [FingerprintJSProHeadersNames.VISITOR_ID]:
      fingerprintJSProResponse?.visitorId ?? null,
    [FingerprintJSProHeadersNames.REQUEST_ID]:
      fingerprintJSProResponse?.requestId ?? null,
  }
}
